import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "row",
  id: "#newFormLink"
}
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-striped table-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ações "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Lista / Grupo "),
    /*#__PURE__*/_createTextVNode(" > ")
  ])
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mt-1 mb-1" }
const _hoisted_8 = { class: "mb-3 text-center" }
const _hoisted_9 = { class: "row g-3" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "LISTA -> GRUPO", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = { class: "mb-1 mt-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Adicionar")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Cancelar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "can-cancel": true,
        "is-full-page": true
      }, null, 8, ["active"])
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.cliptext) = $event))
    }, null, 512), [
      [_vModelText, $setup.cliptext]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userbroadgroups, (ubg) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: ubg.id
              }, [
                _createElementVNode("td", null, [
                  (!($setup.chooselk==ubg.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        id: "#deletelink",
                        title: "Excluir link",
                        onClick: ($event: any) => ($setup.ExcluirLink(ubg.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(ubg.listagroup), 1)
              ]))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, $setup.showlinks]
      ])
    ], 512), [
      [_vShow, !$setup.janela]
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h1", null, [
          _withDirectives(_createElementVNode("a", {
            href: "javascript:void(0)",
            class: "text-muted text-decoreation-none",
            id: "#newLinkForm",
            title: "Add Lista / Grupo",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showNewLinkForm()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ], 512), [
            [_vShow, !$setup.janela]
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.group_id) = $event)),
            class: "form-select text-dark",
            id: "group_id",
            "aria-label": "multiple select example"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listgroups, (g) => {
              return (_openBlock(), _createElementBlock("option", {
                key: g.id,
                value: g.id
              }, _toDisplayString(g.listagroup), 9, _hoisted_12))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.data.group_id]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "btn btn-outline-secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.AddListaGroup()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "ban" }),
            _hoisted_15
          ]),
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "btn btn-outline-secondary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.cancelcadgrupo()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "ban" }),
            _hoisted_16
          ])
        ])
      ])
    ], 512), [
      [_vShow, $setup.janela]
    ])
  ]))
}